import { Text } from "@southfields-digital/mxmz-react-ui";
import classNames from "classnames";

import type { HockeyContestant } from "src/types/matchControl/contestant";

import { AdjustButton, ColorSwatch, ShortNameInput } from "../../components";
import styles from "../../MatchControl.module.scss";

type ScoreRowProps = {
	home: HockeyContestant;
	away: HockeyContestant;
	isCompact?: boolean;
	handleChangeScore: (contestant: HockeyContestant, amount: number) => void;
	handleChangeColor: (
		contestant: HockeyContestant,
		color: "primaryColor" | "secondaryColor",
		value: string,
	) => void;
	handleChangeShortName: (contestant: HockeyContestant, name: string) => void;
};

const ScoreRow = ({
	home,
	away,
	isCompact = false,
	handleChangeScore,
	handleChangeColor,
	handleChangeShortName,
}: ScoreRowProps) => (
	<div className={classNames("flex flex-col gap-6 w-full", isCompact && "!gap-3")}>
		<div className="flex gap-2 justify-around items-center">
			<div className="flex gap-2 flex-1 justify-start items-center">
				<div className="flex">
					<ColorSwatch
						color={home.primaryColor}
						onChange={(color) => handleChangeColor(home, "primaryColor", color)}
						isCompact={isCompact}
					/>
					<ColorSwatch
						color={home.secondaryColor}
						onChange={(color) => handleChangeColor(home, "secondaryColor", color)}
						isCompact={isCompact}
					/>
				</div>

				<Text
					className={classNames("!text-4xl text-center", isCompact ? "w-7" : "w-16")}
					as="h1"
					color="light"
				>
					{home.score.points}
				</Text>
			</div>

			<Text className="!text-4xl" as="h1" color="light">
				-
			</Text>

			<div className="flex gap-2 flex-1 justify-end items-center">
				<Text
					className={classNames("!text-4xl text-center", isCompact ? "w-7" : "w-16")}
					as="h1"
					color="light"
				>
					{away.score.points}
				</Text>

				<div className="flex">
					<ColorSwatch
						color={away.primaryColor}
						onChange={(color) => handleChangeColor(away, "primaryColor", color)}
						isCompact={isCompact}
					/>
					<ColorSwatch
						color={away.secondaryColor}
						onChange={(color) => handleChangeColor(away, "secondaryColor", color)}
						isCompact={isCompact}
					/>
				</div>
			</div>
		</div>

		<div className={styles.CurrentScoreWrapper}>
			<div className="flex flex-col gap-4">
				<div className="flex gap-2 items-center">
					<AdjustButton
						onClick={() => handleChangeScore(home, (home.score.points || 0) - 1)}
						icon="minus"
						title="Subtract score for home team"
						disabled={(home.score.points || 0) < 1}
						isCompact={isCompact}
					/>
					<AdjustButton
						onClick={() => handleChangeScore(home, (home.score.points || 0) + 1)}
						icon="plus"
						title="Add score for home team"
						isCompact={isCompact}
					/>
				</div>

				<ShortNameInput
					value={home.shortName}
					onChange={(name) => handleChangeShortName(home, name)}
					isCompact={isCompact}
				/>
			</div>

			<div className="flex flex-col gap-4">
				<div className="flex gap-2 items-center">
					<AdjustButton
						onClick={() => handleChangeScore(away, (away.score.points || 0) - 1)}
						icon="minus"
						title="Subtract score for away team"
						disabled={(away.score.points || 0) < 1}
						isCompact={isCompact}
					/>
					<AdjustButton
						onClick={() => handleChangeScore(away, (away.score.points || 0) + 1)}
						icon="plus"
						title="Add score for away team"
						isCompact={isCompact}
					/>
				</div>

				<ShortNameInput
					value={away.shortName}
					onChange={(name) => handleChangeShortName(away, name)}
					isCompact={isCompact}
				/>
			</div>
		</div>
	</div>
);

export default ScoreRow;
